module.exports = __webpack_public_path__ + "static/media/Hoist_ios_1.79b84308.jpg";